import {apiBase} from 'api/base.js';

class CowGroupAPI {
  index(farmId) {
    return apiBase.get(`/admin/cow_group?farm_id=${farmId}`);
  }

  show(farmId, id) {
    return apiBase.get(`/admin/cow_group/${id}?farm_id=${farmId}`);
  }

  create(farmId, params) {
    return apiBase.post('/admin/cow_group', params);
  }

  update(id, params) {
    return apiBase.put(`/admin/cow_group/${id}`, params);
  }

  delete(farmId, id) {
    const params = {farmId: farmId};
    return apiBase.delete(`/admin/cow_group/${id}`, params);
  }
}

export const cowGroupAPI = new CowGroupAPI();
